module.exports = new __parcel__URL__("inspect-code.20cbac7f.svg").toString();